import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime/date-time/adapter/date-time-format.class';
import { OWL_datetime_formats } from '../../owl_datetime_formats';
import { SiteDetailService } from '../site-detail';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { DialogHelper, ExceptionHelper } from '../../../../helper';

@Component({
  selector: 'app-site-record-sheet',
  templateUrl: './site-record-sheet.component.html',
  styleUrls: ['./site-record-sheet.component.css'],
  providers: [{ provide: OWL_DATE_TIME_FORMATS, useValue: OWL_datetime_formats }]
})
export class SiteRecordSheetComponent implements OnInit {

  recordSheetForm: FormGroup;
  siteId: string;

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private siteDetailService: SiteDetailService,
    private fb: FormBuilder, private location: Location,
    private route: ActivatedRoute) {
    this.recordSheetForm = this.fb.group({
      description: ['', [Validators.required, Validators.maxLength(1000)]]
    });
  }

  ngOnInit() {
    this.route.params.subscribe(res => {
      this.siteId = res.id;
    });
  }

  addRecordSheet(): void {
    this.siteDetailService.addRecordSheet(this.siteId, this.description.value)
      .subscribe(res => {
        this.dialog.showModal('showSucModalBtn');
      }, error => {
        this.exception.showError(error, 'showDanModalBtn');
      });
  }

  closeSuccessModel(): void { this.location.back(); }

  get description() { return this.recordSheetForm.get('description'); }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-record-sheet/site-record-sheet.component.ts